import { IFeature } from 'mod/featureV2/interface';

export const tabsProducts: IFeature = {
    moduleId: 'tabsProducts_1',
    type: 'tabsProducts',
    title: 'tabsProducts',
    description: 'Tabs Products',
    list: [
        {
            label: {
                text: 'Aero Light',
                styles: {
                    fontSize: '14px',
                    lineHeight: '18px',
                }
            },
            title: {
                text: 'Aero Light',
                styles: {}
            },
            description: {
                text: 'Watch our captivating video to see the VGrow Smart Grow Box in action, and prepare to be amazed by its extraordinary capabilities. Join the ranks of forward-thinking gardeners who are embracing the future of indoor cultivation.',
                styles: {}
            },
            button: {
                text: 'Learn More',
                linkUrl: '/vivosun-smart-grow-box?mock=1',
                styles: {}
            },
            banner: {
                picUrl: 'https://image.next.vivosun.com/asset/width-3840/picture/cbae8c41327742c3fbde03737fae6efe.jpg',
                height: 449,
                width: 1233
            },
            variantIds: [
                '58820960379615910',
                '58820960379602944',
                '141435894443550026',
                '144680331262482551',
                '144680331262482551',
                '58820960379609541',
            ],
        },
        {
            label: {
                text: 'AeroLight SE',
                styles: {
                    fontSize: '14px',
                    lineHeight: '18px',
                    // color: '#00f'
                }
            },
            title: {
                text: 'AeroLight SE',
                styles: {}
            },
            description: {
                text: 'Watch our captivating video to see the VGrow Smart Grow Box in action, and prepare to be amazed by its extraordinary capabilities. Join the ranks of forward-thinking gardeners who are embracing the future of indoor cultivation.',
                styles: {}
            },
            button: {
                text: 'Learn More',
                linkUrl: '/vivosun-smart-grow-box?mock=1',
                styles: {}
            },
            banner: {
                picUrl: 'https://image.next.vivosun.com/asset/width-3840/picture/cbae8c41327742c3fbde03737fae6efe.jpg',
                height: 449,
                width: 1233
            },
            variantIds: [
                '58820960379604080',
                '58820960379609989',
                '58820960379615910',
                '58820960379602944',
                '141435894443550026'
            ],
        },
    ]
};